import type {GenericContent, GenericCTAGroup} from '../../../../../../brand/lib/types/contentful'
import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {Heading, Text, Image} from '@primer/react-brand'
import {CtaButtons} from '../../_shared/CtaButtons/CtaButtons'
import {Label} from '../../_shared/Label/Label'
import {Spacer} from '../../_shared/Spacer/Spacer'
import {ShareButton} from '../../_shared/ShareButton/ShareButton'

import Styles from './Hero.module.css'

type Props = {
  content: GenericContent
  location: string
  sectionId?: string
  sectionIndex: number
}

export function Hero(props: Props) {
  const {content, location, sectionId, sectionIndex} = props
  const {heading, subheading, label, text, ctas, media} = content.fields

  const title = heading
  const subTitle = subheading ? documentToPlainTextString(subheading) : ''

  const eyebrow = label?.fields.text
  const description = text ? documentToPlainTextString(text) : ''
  const ctaGroup = ctas?.at(0) as GenericCTAGroup

  const image = media?.at(0)?.fields

  return (
    <div className={Styles.Hero}>
      <div className={Styles.Cell}>
        {subTitle && <Label className={Styles.SubTitle} text={subTitle} hideIcon />}
        {eyebrow && <Label className={Styles.EyebrowMobile} text={eyebrow} aria-hidden="true" />}

        {title && (
          <Heading data-heading="1" as="h1">
            {title}
          </Heading>
        )}

        {sectionId && sectionIndex > 0 && <ShareButton id={sectionId} location={location} />}
      </div>

      <div className={Styles.Cell}>
        {eyebrow && <Label className={Styles.EyebrowDesktop} text={eyebrow} />}

        <div>
          {description && (
            <Text as="p" className={Styles.Description}>
              {description}
            </Text>
          )}

          {ctas && (
            <>
              <Spacer size="32px" size1280="64px" />
              <CtaButtons contentfulContent={ctaGroup} location={location} />
            </>
          )}
        </div>

        {/* Mascot */}
        {image && (
          <Image
            className={Styles.Image}
            src={image.asset.fields.file.url}
            alt={image.description || ''}
            width={image.width || '230'}
            height={image.height || '230'}
          />
        )}
      </div>
    </div>
  )
}

try{ Hero.displayName ||= 'Hero' } catch {}